import { Typo } from "~/components/Typo";
import { useRootMatchData } from "~/root";
import { cn } from "~/utils/classnames";

import "./QuestionCard.css";
import type { QuestionCardProps } from "./QuestionCard.types";

/**
 * Composant pour afficher un contact de l'entreprise en cas de question.
 */
export const QuestionCard = ({ className, ...props }: QuestionCardProps) => {
  const rootData = useRootMatchData();

  const salesman = rootData?.contact?.salesMan;

  return (
    <div className={cn("QuestionCard", className)} {...props}>
      <Typo as="p" fontSize="xl" fontWeight="semibold">
        Une question ?
      </Typo>
      <Typo as="p">{salesman?.fullName}</Typo>
      {salesman?.imageUrl ? (
        <img
          className="h-24 w-24 rounded-full"
          src={salesman.imageUrl}
          alt="Commercial Powr Connect"
        />
      ) : (
        <Typo>Contactez-nous</Typo>
      )}
      <Typo as="span" fontWeight="semibold">
        {salesman?.email}
      </Typo>

      {salesman?.phone || salesman?.mobile ? (
        <div className="QuestionCard-phone">
          <Typo
            as="a"
            fontWeight="semibold"
            href={`tel:${salesman.phone || salesman.mobile}`.replace(" ", "")}
          >
            {salesman.phone || salesman.mobile}
          </Typo>
        </div>
      ) : null}
      <div className="QuestionCard-phone">
        <Typo as="span" fontWeight="medium">
          Téléphone du standard :{" "}
        </Typo>
        <Typo as="a" fontWeight="semibold" href="tel:0228443121">
          02 28 44 31 21
        </Typo>
      </div>

      <Typo as="span" fontSize="sm">
        A votre écoute du lundi au vendredi de 8h30 à 12h30 et de 14h00 à 18h00
      </Typo>
    </div>
  );
};
